import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from 'vue';

// ! There are separate props also in BadgeProps.ts file,
// ! due to vue version, we cannot use imported types in the component itself
// ! so we have to duplicate the types to use in ts files
export interface Props {
    size?: 's' | 'l',
    type?: 'error' | 'success' | 'info',
    text?: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Badge',
  props: {
    size: { default: 's' },
    type: { default: 'info' },
    text: null
  },
  setup(__props: any) {

const props = __props as { size: 's' | 'l', type: 'error' | 'success' | 'info', text?: string };



const {
    size,
    type,
    text,
} = toRefs(props);


return { __sfc: true,props, size, type, text }
}

})